<template>
  <div class="mailing-list-signup">
    {{ description }}
    <div id="mc_embed_signup">
      <form action="https://rewardingdogtraining.us14.list-manage.com/subscribe/post?u=598a7ba9e30732df00d5995e3&amp;id=7a35fdcb49" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll">
          <div class="mailing-list-email">
            <label for="mce-EMAIL">Join mailing list </label>
            <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
          </div>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input type="text" name="b_598a7ba9e30732df00d5995e3_7a35fdcb49" tabindex="-1" value="">
          </div>
          <div class="optionalParent">
            <div class="clear foot">
              <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
              <!-- <p class="brandingLogo"><a href="http://eepurl.com/hUjR3r" title="Mailchimp - email marketing made easy and fun"><img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg"></a></p> -->
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mailing-list-signup',
  props: {
    description: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
.mailing-list-signup {
  width: 100%;

  #mc_embed_signup {
    margin-top: 1rem;

    #mc_embed_signup_scroll {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .mailing-list-email {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 2.375rem;
        border-style: solid;
        border-width: 0 0 thin 0;
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
        background-color: rgb(245, 248, 249);
        border-color: rgb(131, 150, 165);

        label {
          padding: 0.2rem 0.5rem;
          margin-bottom: 0.5rem;
          max-width: calc(100% - 0.25rem);
          color: rgb(22, 104, 211);
          font-size: 0.625rem;
          letter-spacing: 0.0375rem;
          line-height: 1.2;
          font-weight: bold;
          text-transform: uppercase;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          -webkit-transform-origin: top left;
          transform-origin: top left;
        }

        input {
          width: 100%;
          height: 1.5rem;
          margin-bottom: 0.125rem;
          padding: 0.25rem 0.5rem;
          color: #34495e;
          background-color: transparent;
          border-style: none;
          outline: none;
          font-size: 1rem;
          // font-family: "Source Sans Pro", sans-serif;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: normal;
        }
      }
    }

    .foot {
      display: flex;
      flex-direction: column;
      align-items: center;

      .button {
        margin-top: 1rem;
        border-radius: 0.375rem;
        max-width: 90%;
        width: 90%;
        margin-left: 1rem;
        background-image: linear-gradient(to right, rgb(20, 160, 225), rgb(22, 105, 212));
        color: rgb(255, 255, 255);
        outline: none;
        border: 0;
        padding: 0.375rem 1.25rem;
        font-size: 1rem;
        line-height: 1.5;
        letter-spacing: 0.032rem;
        text-decoration: none !important;
        text-transform: initial;
        font-weight: 700;
        cursor: pointer;
        -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
    }
  }
}
</style>
